export const WARRANTY = 'warranty';
